"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const RootLayoutLayer = (props) => {
    const [isMounted, setIsMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const rootEl = document.querySelector('.Kalend__Calendar__root');
        if (rootEl) {
            setIsMounted(true);
        }
    }, [document.querySelector('.Kalend__Calendar__root')]);
    return isMounted ? props.children : null;
};
exports.default = RootLayoutLayer;
